import React from "react";
import { Users, ShieldCheck, Network, Scale, SearchCheck, Landmark } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Eyebrow, Section, SectionTitle, Lead } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

const ICONS = { users: Users, "shield-check": ShieldCheck, network: Network, scale: Scale, "search-check": SearchCheck, landmark: Landmark };

export const WhyGpu = () => {
  const { t } = useI18n();
  const cards = t("home.why.cards") || [];

  return (
    <Section className="py-24 sm:py-32" grid data-testid="why-gpu-section">
      <div className="grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-end">
        <Reveal>
          <Eyebrow>{t("home.why.eyebrow")}</Eyebrow>
          <SectionTitle className="mt-6 max-w-[18ch]">{t("home.why.title")}</SectionTitle>
        </Reveal>
        <Reveal delay={0.12}>
          <Lead className="max-w-lg lg:pb-3">{t("home.why.sub")}</Lead>
        </Reveal>
      </div>

      <Stagger className="mt-16 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((c) => {
          const Icon = ICONS[c.icon] || ShieldCheck;
          return (
            <StaggerItem key={c.n} className="bg-white">
              <div
                className="group h-full p-8 transition-colors duration-500 hover:bg-navy sm:p-10"
                data-testid={`why-card-${c.n}`}
              >
                <div className="flex items-start justify-between">
                  <Icon
                    className="h-7 w-7 text-grn transition-colors duration-500 group-hover:text-gold"
                    strokeWidth={1.4}
                    aria-hidden="true"
                  />
                  <span className="font-mono text-[11px] tracking-[0.2em] text-navy/25 transition-colors duration-500 group-hover:text-white/30">
                    {c.n}
                  </span>
                </div>
                <h3 className="mt-10 font-display text-xl font-semibold text-navy transition-colors duration-500 group-hover:text-white">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600 transition-colors duration-500 group-hover:text-white/60">
                  {c.body}
                </p>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </Section>
  );
};
